import { createFileRoute, Outlet } from "@tanstack/react-router";
import { StepFlowLayout } from "~/components/layouts/StepFlowLayout";

export const Route = createFileRoute("/(authenticated)/betaling-instellen")({
  component: () => (
    <StepFlowLayout>
      <Outlet />
    </StepFlowLayout>
  ),
});
